module.exports = __webpack_public_path__ + "3ae7c6abd9385698351640cd568e6f1c.pdf";